import NewAuthLayout from '../layout/Layout';
import TenantLogin from '../Components/TenantLogin';

interface LoginProps {
	isAdminLogin: boolean;
}

export default function Login({ isAdminLogin }: LoginProps) {
	return (
		<NewAuthLayout showPortalBtn={isAdminLogin}>
			{!isAdminLogin && <TenantLogin />}
		</NewAuthLayout>
	);
}
